module.exports = __webpack_public_path__ + "static/media/results-image4.b341e91e.png";